import React from "react";
import { FaTimes, FaCloudUploadAlt, FaMicrophone } from "react-icons/fa";
import AppModal from "./AppModal";

const FollowupModal = ({ showFollowup, setShowFollowup }) => {
  return (
    <AppModal
      show={showFollowup}
      setShow={setShowFollowup}
      title="Add Lead Followup"
      size="modal-md"
      footer={
        <>
          <button className="btn btn-primary">Submit</button>

          <button
            className="btn btn-danger"
            onClick={() => setShowFollowup(false)}
          >
            Cancel
          </button>
        </>
      }
    >
      <div className="modal-body p-1">
        {/* Date */}
        <div className="mb-2">
          <label className="form-label">
            Next Followup Date: <span>*</span>
          </label>

          <input type="datetime-local" className="form-control" />
        </div>

        {/* Quick Reply */}
        <div className="quick-reply d-flex gap-2 mb-2">
          <span className="badge">busy call</span>
          <span className="badge">chr</span>
          <span className="badge">switch off</span>
        </div>

        {/* Comment */}
        <div className="mb-3">
          <label className="form-label">
            Comment / message: <span>*</span>
          </label>

          <div className="message-box">
            <textarea
              rows="4"
              className="form-control"
              placeholder="Enter Message"
            ></textarea>
          </div>
        </div>

        {/* Upload */}
        <div className="mb-3">
          <label className="form-label">Attachment: (Optional)</label>

          <div className="upload-wrapper">
            <div className="upload-box">
              <FaCloudUploadAlt className="upload-icon" />

              <h6>Drop Files here or click to upload</h6>

              <p>Allowed IMAGES, VIDEOS, PDF, DOC, EXCEL, PPT, TEXT</p>

              <span>max size of 5 MB</span>

              <input type="file" />
            </div>

            <button className="voice-btn">
              <FaMicrophone />
            </button>
          </div>
        </div>
      </div>
    </AppModal>
  );
};

export default FollowupModal;
